
import React from 'react';
import { useCookieConsent } from './CookieConsentProvider';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

interface CookieSettingsLinkProps {
  className?: string;
}

const CookieSettingsLink: React.FC<CookieSettingsLinkProps> = ({ className = '' }) => {
  const { showConsentManager } = useCookieConsent();

  return (
    <span
      onClick={showConsentManager}
      className={`${className} hover:text-white transition-colors inline-flex items-center gap-1 text-gray-400`}
    >
      Cookie-instellingen
    </span>
  );
};

export default CookieSettingsLink;
